import React, { useState } from "react";
import { Container, Nav, Navbar, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  let page = useLocation();

  const usePathname = () => {
    return location.pathname;
  };

  const [scrolled, setScrollEffect] = useState(false);

  const listenForScrollEvent = () => {
    if (window.scrollY >= 80) {
      setScrollEffect(true);
    } else {
      setScrollEffect(false);
    }
  };
  window.addEventListener("scroll", listenForScrollEvent);

  let buttonClassName = "";

  if (page.pathname === "/contact") {
    buttonClassName = "btn btn-site-clicked";
  } else {
    buttonClassName = "btn btn-site";
  }

  return (
    <Navbar
      collapseOnSelect
      fixed="top"
      className={scrolled ? "navbar-filled" : "navbar"}
      expand="lg"
      variant="dark"
    >
      <Container>
        <Navbar.Brand href="/">Your Logo Here</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav
            defaultActiveKey={usePathname}
            className="margin-left-right-auto"
          >
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/services">Services</Nav.Link>
            <Nav.Link href="/gallery">Gallery</Nav.Link>
            <Nav.Link href="/prices">Prices</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link className="contact-button-alt" href="/contact">
              Contact
            </Nav.Link>
          </Nav>
          <Nav className="contact-button">
            <Nav.Link href="/contact">
              <Button className={buttonClassName}>Contact</Button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
